import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';


export default /*#__PURE__*/_defineComponent({
  __name: 'crop-pic',
  props: {
  src: {
    type: String,
    default: '',
  },
  handleCropChange: {
    type: Function,
    default: () => {},
  },
  width: {
    type: Number,
    default: 100,
  },
  height: {
    type: Number,
    default: 100,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Cropper), {
    class: "cropper",
    src: __props.src,
    "default-size": { width: __props.width, height: __props.height },
    onChange: __props.handleCropChange
  }, null, 8, ["src", "default-size", "onChange"]))
}
}

})